var _rect, _g, _rect2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCorrectPrimary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 13,
    fill: "#D5D5D5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Patient Profile"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 24618",
    x: -7926,
    y: -3317,
    width: 11861,
    height: 5385,
    fill: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Timeline state"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 716,
    height: 2213,
    transform: "translate(-469 -2043)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 24659",
    filter: "url(#filter0_d_314_387)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -419,
    y: -257,
    width: 616,
    height: 319,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Button"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -13.5,
    y: -12.5,
    width: 168,
    height: 38,
    rx: 7.5,
    fill: "#F5F4FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6952 0.810122C16.1016 1.22362 16.1016 1.89403 15.6952 2.30753L5.98167 12.1899C5.57524 12.6034 4.91628 12.6034 4.50985 12.1899L0.30483 7.91177C-0.101602 7.49827 -0.101602 6.82786 0.30483 6.41436C0.711261 6.00087 1.37022 6.00087 1.77665 6.41436L5.24576 9.94377L14.2234 0.810122C14.6298 0.396626 15.2887 0.396626 15.6952 0.810122Z",
    fill: "#735BF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -13.5,
    y: -12.5,
    width: 168,
    height: 38,
    rx: 7.5,
    stroke: "#735BF2"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -24483,
    y: -4829,
    width: 30445,
    height: 12277,
    stroke: "black",
    strokeWidth: 10
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 24706",
    x: -40140.5,
    y: -29432.5,
    width: 48585,
    height: 38830,
    stroke: "black",
    strokeWidth: 15
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_314_387",
    x: -449,
    y: -284,
    width: 676,
    height: 379,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0588235 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_314_387"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_314_387",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCorrectPrimary);
export default __webpack_public_path__ + "static/media/IconCorrectPrimary.e5e41eec166b483e17ab3447e4d20079.svg";
export { ForwardRef as ReactComponent };